import { Component, OnInit } from '@angular/core';
import { Outcome } from 'src/app/models/outcomes/Outcome';
import { OutcomesService } from 'src/app/services/outcomes.service';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-view-outcome-sub-outcomes-modal',
  templateUrl: './view-outcome-sub-outcomes-modal.page.html',
  styleUrls: ['./view-outcome-sub-outcomes-modal.page.scss'],
})
export class ViewOutcomeSubOutcomesModalPage implements OnInit {

  public outcome: Outcome;
  public subOutcomes: Outcome[];
  public paginateConfig: any;
  public key: string = 'title'; // Default field
  public reverse: boolean = false;  // Default Sort (false = Ascending)
  public caretDownIcon = 'arrow-dropdown';
  public caretUpIcon = 'arrow-dropup';
  public isModalOpen: boolean = false;

  constructor(
    public outcomeService: OutcomesService,
    public unfocusService: UnfocusElementService,
    public modalController: ModalController
  ) { 
    this.paginateConfig = {
      itemsPerPage: 4,
      currentPage: 1
    };
  }

  ngOnInit() {
  }

  closeModal() {
    this.modalController.dismiss();
  }

  async addSubOutcome(event,outcome){
    this.unfocusService.unfocus(event);
    if(this.isModalOpen === true) return;
    this.isModalOpen = true;
    var addModal = await this.outcomeService.openAddOutcomeToGroupModal(outcome.outcomeId);
    addModal.onDidDismiss().then(x=>{
      this.updateSubOutcomes();
      this.isModalOpen = false;
    })
  }

  updateSubOutcomes(){
    this.outcomeService.getOutcomeForGroup(this.outcome.outcomeId).subscribe(outcomesAdded => {
      this.outcomeService.getSubOutcomesOnlyFromDb().then(x=>{
        this.subOutcomes = this.outcomeService.outcomes.filter(x => outcomesAdded.find(y => y.outcomeId == x.outcomeId));
      }
      );
    });
  }

  sortBy(key: string) {
    if (this.key != key) {
      this.key = key;
      this.reverse = false;
    } else {
      this.reverse = !this.reverse;
    }
  }

}
